var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBooster({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 149 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Booster"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 23",
    d: "M44.7969 114.836L34.1204 104H23.1204L44.7969 126V114.836Z",
    fill: "#135FC2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 20",
    d: "M32.631 137.209C32.3567 144.763 13.5456 147.55 4.17428 148C1.98003 126.419 9.88847 119.674 14.117 119C31.1224 119 33.5452 131.14 32.631 137.209Z",
    fill: "#135FC2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 21",
    d: "M64.7053 144.674C64.554 149.102 54.1755 150.736 49.0051 151C47.7945 138.349 52.1578 134.395 54.4907 134C63.873 134 65.2098 141.116 64.7053 144.674Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 22",
    d: "M16.7053 94.0465C16.554 98.214 6.17545 99.7519 1.0051 100C-0.205525 88.093 4.15775 84.3721 6.49072 84C15.873 84 17.2098 90.6977 16.7053 94.0465Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.0556 109.823L39.5998 84.3668C39.8826 86.3467 36.4178 90.8486 34.65 92.8521L56.9239 115.126C57.4896 112.863 62.5808 110.648 65.0556 109.823Z",
    fill: "#135FC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.057 77.6493L72.1267 49.7185C58.5503 58.7695 48.3208 71.6389 44.9031 76.9422L73.5409 105.58C84.2889 98.2261 95.6969 83.8954 100.057 77.6493Z",
    fill: "#135FC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4074 78.7099L19.0937 77.2957C15.6996 65.982 38.1856 56.7896 49.8528 53.6076C41.9332 57.0017 33.5894 71.7567 30.4074 78.7099Z",
    fill: "#135FC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.947 68.1033L81.6726 45.8295C85.9153 39.3241 97.8183 39.1119 103.239 39.8191L114.553 28.5053C121.059 28.2225 121.742 32.8658 121.271 35.2229L109.957 46.5366C112.22 55.5875 106.893 64.6856 103.947 68.1033Z",
    fill: "#135FC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7732 129.975L70.0054 118.308C70.8539 121.985 88.9794 107.348 97.9361 99.5696C86.0567 127.288 75.5444 131.389 71.7732 129.975Z",
    fill: "#135FC2"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1908",
    cx: 73.2666,
    cy: 77.1084,
    r: 11,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1909",
    cx: 73.2666,
    cy: 77.1084,
    r: 5,
    fill: "#135FC2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooster);
export default __webpack_public_path__ + "static/media/Booster.9854b67fc134b719de891cb5e65be3cc.svg";
export { ForwardRef as ReactComponent };